import type { ResultsData } from '../api/types'

/** The candidate's own results, as shown at the end of the test. Plain, calm, and explained. */
export default function ResultsPanel({ r }: { r: ResultsData }) {
  return (
    <div className="stack" aria-label="Your results">
      <header className="results-head">
        {r.hasLogo && <img className="inst-logo" src={`/api/public/institutions/${r.institutionSlug}/logo`} alt="" width={120} height={48} />}
        <div>
          <strong>{r.institutionName}</strong>
          <div className="muted">Results for {r.candidateName} · {r.reportDate}</div>
        </div>
      </header>
      {r.provisional && <div className="notice info">Some percentiles are provisional and may change slightly until the test window closes.</div>}
      {r.combined && (
        <section className="card">
          <h2>Your combined score</h2>
          <p className="score-big">{r.combined.score} <small>/ {r.combined.max}</small></p>
          <p className="muted">{r.combined.breakdown}</p>
          {r.combined.note && <p className="muted">{r.combined.note}</p>}
        </section>
      )}
      {r.vusat && (
        <section className="card">
          <h2>{r.vusat.title}</h2>
          <p className="muted">{r.vusat.subtitle}</p>
          <div className="results-grid two">
            <div><p className="score-big">{r.vusat.total} <small>/ {r.vusat.max} ({r.vusat.pct})</small></p><p className="muted">{r.vusat.weightsNote}</p></div>
            <ul className="plain">
              <li>Percentile: <strong>{r.vusat.percentile}</strong> {r.vusat.percentileOf}</li>
              <li>Attempted: <strong>{r.vusat.attempted}</strong> ({r.vusat.blank})</li>
              <li>Time used: <strong>{r.vusat.timeUsed}</strong> {r.vusat.ofTime}</li>
            </ul>
          </div>
          <table className="results">
            <thead><tr><th>Section</th><th>Marks</th><th>Percentile</th></tr></thead>
            <tbody>{r.vusat.sections.map((s) => <tr key={s.name}><td>{s.name}</td><td>{s.marks}</td><td>{s.percentile}</td></tr>)}</tbody>
          </table>
        </section>
      )}
      {r.mi && (
        <section className="card">
          <h2>{r.mi.title}</h2>
          <p className="score-big">{r.mi.marks} <small>/ {r.mi.max}</small></p>
          <p className="muted">{r.mi.fitLine}. {r.mi.formula}</p>
          <table className="results">
            <thead><tr><th>Intelligence</th><th>Score</th><th>Level</th></tr></thead>
            <tbody>{r.mi.rows.map((i) => (
              <tr key={i.name}>
                <td>{i.name}{i.fit && <> <span className="badge">fit</span></>}</td>
                <td style={{ width: '40%' }}><div className="meter" role="img" aria-label={`${i.name}: ${i.pct} percent`}><i style={{ width: `${i.pct}%` }} /></div></td>
                <td>{i.pct}% · {i.band}</td>
              </tr>
            ))}</tbody>
          </table>
          {r.mi.studyAreas.length > 0 && <p><strong>Study areas to explore:</strong> {r.mi.studyAreas.join(', ')}</p>}
          {r.mi.careers.length > 0 && <p><strong>Careers to explore:</strong> {r.mi.careers.join(', ')}</p>}
        </section>
      )}
      <p className="muted">{r.howCalculated}</p>
    </div>
  )
}
